// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "InsightCategoriesRibbon__regular__eLBMd";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const categoryWidth = "96px";
export const menu = "InsightCategoriesRibbon__menu__nVexV";
export const ribbon = "InsightCategoriesRibbon__ribbon__4lyww font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const white = "InsightCategoriesRibbon__white__fgB2I";
export const dragging = "InsightCategoriesRibbon__dragging__9J4Ri";
export const category = "InsightCategoriesRibbon__category__ugiy3";
export const icon = "InsightCategoriesRibbon__icon__9mFCm";
export const scrollable = "InsightCategoriesRibbon__scrollable__Ug0sg";
export const arrow = "InsightCategoriesRibbon__arrow__s4P-W";
export const left = "InsightCategoriesRibbon__left__nF6Ef";
export const right = "InsightCategoriesRibbon__right__GdKE9";
export const hidden = "InsightCategoriesRibbon__hidden__0uCF3";
export const selected = "InsightCategoriesRibbon__selected__g7zuX";
export const iconContainer = "InsightCategoriesRibbon__iconContainer__8Yg8x";
export const textPositioner = "InsightCategoriesRibbon__textPositioner__DnUtc";
export const textWrapper = "InsightCategoriesRibbon__textWrapper__nTqK3";
export const highlighter = "InsightCategoriesRibbon__highlighter__gMaVl";
export const counterWrapper = "InsightCategoriesRibbon__counterWrapper__Cjrou";